import { Box } from '@mui/material';

import { StyledContentContainer } from '../style';
import NursingRecords from './NursingRecords';
import Advertisement from './Advertisement';
import PatientHandoverSection from './PatientHandoverSection';

export const inputInformationWidth = { xs: 340, xl: 530 };

interface Props {
  coachRefA: any;
  coachRefB: any;
  isDesktopLayout: boolean;
}

const InputInformation = ({
  coachRefA,
  coachRefB,
  isDesktopLayout,
}: Props) => {
  return (
    <Box
      component="aside"
      width={isDesktopLayout ? inputInformationWidth : '100%'}
      flexShrink={0}
      sx={{ minWidth: 0 }}
    >
      {isDesktopLayout && <Advertisement />}

      <StyledContentContainer>
        {isDesktopLayout && <PatientHandoverSection coachRef={coachRefA} />}
        <NursingRecords coachRef={coachRefB} />
      </StyledContentContainer>
    </Box>
  );
};

export default InputInformation;
